import React from 'react';
export default function NetworkQualityLevel(_ref) {
  var qualityLevel = _ref.qualityLevel;
  if (qualityLevel === null) return null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("indicator", {
    size: "12",
    qualityLevel: qualityLevel
  }), /*#__PURE__*/React.createElement("indicator", {
    size: "18",
    qualityLevel: qualityLevel
  }), /*#__PURE__*/React.createElement("indicator", {
    size: "24",
    qualityLevel: qualityLevel
  }));
}